import { useContext } from 'react';
import { NavigationConfigContext } from '@/contexts';

export const useNavigationConfig = () => {
	const navigationConfigContext = useContext(NavigationConfigContext);
	return navigationConfigContext;
};
